module.exports = __webpack_public_path__ + "static/media/homepage-inclusione.55ca7aaf.jpg";